import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { ActivatedRoute, Router} from '@angular/router';
import {SessionService} from '../../../Services/session.service';
import {Subscription} from 'rxjs';
import {AppSettings} from '../../../app-settings';
import {HttpClientService} from '../../../Services/http-client.service';
import {UserService} from '../../../Services/user.service';
import { trigger, style, animate, transition } from '@angular/animations';



@Component({
  selector: 'app-header-batch',
  templateUrl: './header-batch.component.html',
  styleUrls: ['./header-batch.component.css'],
   animations: [
   trigger(
      'pspSubMenuAnimate', [
        transition(':enter', [
          style({height:0}),
          animate('200ms', style({height:'*'}))
        ]),
        transition(':leave', [
          style({height:'*'}),
          animate('200ms', style({height:0}))
        ])
      ]
    ),
   trigger('coursePopUpInOut', [
    transition(':enter', [
          style({opacity: 0}),
          animate('0.3s', style({opacity: 1}))
        ]),
    transition(':leave', [
          style({opacity: 1}),
          animate('0.3s', style({opacity: 0}))
        ])
    ])
   ]
})
export class HeaderBatchComponent implements OnInit {
  verbalClicked = false;
  quantClicked = false;
  verbalMenu=[
    {label:"Your GMAT Roadmap",courseURL:"https://blitzkrieg.e-gmat.com/secure-lms/page/your_study_plan"},
    {label:"Sentence Correction",courseURL:"https://blitzkrieg.e-gmat.com/secure-lms/page/sentence_correction"},
    {label:"Critical Reasoning",courseURL:"https://blitzkrieg.e-gmat.com/secure-lms/page/critical_reasoning"},
    {label:"Reading Comprehension",courseURL:"https://blitzkrieg.e-gmat.com/secure-lms/page/reading_comprehension"},
    {label:"Master Comprehension",courseURL:"https://blitzkrieg.e-gmat.com/secure-lms/page/master_comprehension"},
    {label:"Integrated Reasoning",courseURL:"https://blitzkrieg.e-gmat.com/secure-lms/page/integrated_reasoning"},
    {label:"Verbal Scholaranium",courseURL:"https://scholaranium.e-gmat.com/?section=verbal"}
  ];
  quantMenu=[
    {label:"Your GMAT Roadmap",courseURL:"https://blitzkrieg.e-gmat.com/secure-lms/page/your_study_plan"},
    {label:"Number Properties",courseURL:"https://blitzkrieg.e-gmat.com/secure-lms/page/number_properties"},
    {label:"Word Problems",courseURL:"https://blitzkrieg.e-gmat.com/secure-lms/page/word_problems"},
    {label:"Algebra",courseURL:"https://blitzkrieg.e-gmat.com/secure-lms/page/algebra"},
    {label:"Geometry",courseURL:"https://blitzkrieg.e-gmat.com/secure-lms/page/geometry"},
    {label:"Advanced Topics",courseURL:"https://blitzkrieg.e-gmat.com/secure-lms/page/advanced_topics"},
    {label:"Quant Scholaranium",courseURL:"https://scholaranium.e-gmat.com/?section=quant"}
  ];
  username:string='';

  constructor(private httpClientService: HttpClientService, private route: ActivatedRoute, private userService: UserService, private router: Router, private sessionService: SessionService) {

  }

  ngOnInit()
  {
    this.getUserProfile();
  }

    getUserProfile()
    {
      let headers = new HttpHeaders();
      this.httpClientService.get(AppSettings.restApiUrl + '/api/user/info', headers)
        .subscribe(
        (data) => {
          this.username = data.firstName;
      }
      );
    }

  ngOnDestroy()
  {

  }

  toggleHamburgerMenu(){

    this.hideQuantSubMenu();
    this.hideVerbalSubMenu();

    var el = document.getElementById('menuContainer');
    var hamburgerparent = document.getElementsByClassName('hamburgerMenu')[0];
    hamburgerparent.classList.toggle('hamburgerOpen');
    el.classList.toggle('open');
  }

  toggleMockMenu(){
    var el = document.getElementsByClassName('inputMockMenu')[0];
    var parent = document.getElementsByClassName('mockMenuInputContainer')[0];
    parent.classList.toggle('openMenu');
    el.classList.toggle('open');
  }

  showHideSubMenu(option){

      if(option == "verbal"){
          this.hideQuantSubMenu();
          if(this.verbalClicked)
              this.hideVerbalSubMenu();
          else
              this.showVerbalSubMenu();
      }
      else if(option == "quant"){
          this.hideVerbalSubMenu();
          if(this.quantClicked)
              this.hideQuantSubMenu();
          else
              this.showQuantSubMenu();
      }
  }
  hideQuantSubMenu(){
    this.quantClicked = false;
    document.getElementById('quantSubMenu').classList.remove('rotateSubItemIcon');
  }
  showQuantSubMenu(){
    this.quantClicked = true;
    document.getElementById('quantSubMenu').classList.add('rotateSubItemIcon');
  }
  hideVerbalSubMenu(){
    this.verbalClicked = false;
    document.getElementById('verbalSubMenu').classList.remove('rotateSubItemIcon');
  }
  showVerbalSubMenu(){
    this.verbalClicked = true;
    document.getElementById('verbalSubMenu').classList.add('rotateSubItemIcon');
  }
  logout(){
    this.userService.logout();
  }
  routeToURL(courseURL){
    window.location.href = courseURL;
  }
  routeBack()
  {
     window.history.back();
  }
}
